<template>
    <prism-table :prisms="prisms" />
</template>

<script>
import PrismTable from "@/modules/simulator/components/BPrismTable";

export default {
    name: "OutputResults",
    components: {
        PrismTable
    },
    computed: {
        vtkFiles() {
            return this.$store.state.campos_novos.simulator.vtk_files;
        },
        results() {
            return this.$store.state.campos_novos.simulator.results;
        },
        prisms() {
            return this.results.prisms.filter(prism => prism !== null);
        }
    }
};
</script>
